import urlJoin from "url-join";

export const wsmFitmentSectionUrlName = "/wsm/fitment";

// Schemas: what a shopper picks a vehicle (or a tire size) by.
export const wsmFitmentSchemaListPath = urlJoin(wsmFitmentSectionUrlName, "schemas") + "/";
export const wsmFitmentSchemaAddPath = urlJoin(wsmFitmentSchemaListPath, "add");
export const wsmFitmentSchemaPath = (id: string) => urlJoin(wsmFitmentSchemaListPath, id);
export const wsmFitmentSchemaUrl = (id: string) => wsmFitmentSchemaPath(encodeURIComponent(id));

// Applications live under their schema: the columns are the schema's axes.
export const wsmFitmentApplicationListPath = (schemaId: string) =>
  urlJoin(wsmFitmentSchemaPath(schemaId), "applications") + "/";
export const wsmFitmentApplicationListUrl = (schemaId: string) =>
  wsmFitmentApplicationListPath(encodeURIComponent(schemaId));

// Axes: Year, Make, Model; each with its values.
export const wsmFitmentAxisListPath = urlJoin(wsmFitmentSectionUrlName, "axes") + "/";
export const wsmFitmentAxisAddPath = urlJoin(wsmFitmentAxisListPath, "add");
export const wsmFitmentAxisPath = (id: string) => urlJoin(wsmFitmentAxisListPath, id);
export const wsmFitmentAxisUrl = (id: string) => wsmFitmentAxisPath(encodeURIComponent(id));

// Qualifiers: Cab = Crew Cab; each with its values.
export const wsmFitmentQualifierListPath = urlJoin(wsmFitmentSectionUrlName, "qualifiers") + "/";
export const wsmFitmentQualifierAddPath = urlJoin(wsmFitmentQualifierListPath, "add");
export const wsmFitmentQualifierPath = (id: string) => urlJoin(wsmFitmentQualifierListPath, id);
export const wsmFitmentQualifierUrl = (id: string) =>
  wsmFitmentQualifierPath(encodeURIComponent(id));
